
const slideDown = (target, duration=500) => {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
  
    if (display === 'none')
      display = 'block';
  
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout( () => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }
class Ingredient {
  constructor(parent) {
    if (!parent) {
      return;
    }
    this.parent = parent;
    this.clickEvent();
  }

  clickEvent = () => {
    let deskView = false;
    if (screen.width > 767) {
      deskView = true
    }
    let parent = this.parent;
    let openArticle = qsa(".open-article-js", parent);
    let ingredientContent = qsa(".ingredient-content-js", parent);
    let ingredientContentDesktop = qsa(".ingredient-content-desktop-js", parent);
    let closeIcon = qsa(".close-icon-js", parent);
    let articleListLis = qsa('.article-list-li-js');
    this.closeAction(closeIcon,deskView);
    openArticle?.forEach((item) => {
      item.addEventListener("click", () => {
        articleListLis?.forEach((li) => {
          li.classList.remove('active');
        })
        let articleListLi = item.closest('.article-list-li-js');
        articleListLi?.classList.add('active');
        if (deskView) {
          ingredientContentDesktop?.forEach((deskinItem) => {
            deskinItem.removeAttribute('style');
            deskinItem.classList.remove('active');
          });
          let itemIndex = item.dataset?.index;
          let acitveContent = item.nextElementSibling;
          let igContent = qs(`.ig-content-${itemIndex}-js`,parent);
          if (acitveContent && igContent) {
            igContent.innerHTML = acitveContent.innerHTML;
            slideDown(igContent, 1000);
            igContent.classList.add('active');
            closeIcon = qsa(".close-icon-js", parent);
            this.closeAction(closeIcon,deskView);
            simply.productCardGlobal(qsa('.product-main-js'));
          }
        }else {
          ingredientContent?.forEach((inItem) => {
            inItem.removeAttribute('style');
            inItem.classList.remove('active');
          });
          slideDown(item.nextElementSibling, 1000);
          item.nextElementSibling.classList.add('active');
        }
      });
    });
  };

  closeAction = (closeIcon,deskView) => {
    let parent = this.parent;
    closeIcon?.forEach((closeItem) => {
      closeItem.addEventListener("click", () => {
        qs('.article-list-li-js.active')?.classList.remove("active");
        if (deskView) {
          qs(".ingredient-content-desktop-js.active", parent).removeAttribute('style');
          qs(".ingredient-content-desktop-js.active", parent).classList.remove("active");
        }else {
          qs(".ingredient-content-js.active", parent).removeAttribute('style');
          qs(".ingredient-content-js.active", parent).classList.remove("active");
        }
      });
    });
  }
}
new Ingredient(qs(".ingredient-blog-page-js"));
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    new Ingredient(qs(".ingredient-blog-page-js"));
  });
}
